import { includes } from 'lodash';

const isVehicleShopperEnabled = path => {
  return (
    !includes(path, 'locate-a-vehicle-near-you') &&
    !includes(path, 'locate-vehicle')
  );
};

export default isVehicleShopperEnabled;
